import React from 'react';
import { Toggle } from '../ApeUI';
import Tooltip from '../ApeUI/Tooltip/Tooltip';

const Section = ({
  style, title, children, className, includeToggleButton, onToggle, isChecked, readOnly, tooltip, headerExtra,
}) => {
  const toggle = <Toggle toggled={isChecked} onChange={onToggle} disabled={readOnly} />;

  return (
    <div style={style} className={`section ${readOnly ? 'readonly' : ''} ${className || ''}`}>
      <div className={`form-title ${headerExtra ? 'form-title--with-extra' : ''}`}>
        <span className="section-title-text">{title}</span>
        {headerExtra}
        {includeToggleButton && (tooltip
          ? <Tooltip title={tooltip}><span className="section-toggle">{toggle}</span></Tooltip>
          : toggle)}
      </div>
      <div className="section-content">
        {children}
      </div>
    </div>
  );
};

export default Section;
